import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import React from "react";
import { useTranslation } from "react-i18next";

// Overlay shown OVER the streak modal when the streak is at risk.
// Sits absolutely inside the Dialog Paper and blurs/dims everything behind.
const StreakAtRisk = ({ open = false, busy = false, price, onBuy, onStartFresh, onLater }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 20,
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        background: "rgba(8,10,18,0.55)",
        backdropFilter: "blur(7px)",
        WebkitBackdropFilter: "blur(7px)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 440,
          borderRadius: 4,
          p: { xs: 2.5, sm: 3 },
          background: "#fff",
          boxShadow: "0 30px 70px -20px rgba(0,0,0,0.7)",
        }}
      >
        {/* Header banner */}
        <Box
          sx={{
            borderRadius: 3,
            p: 2.5,
            mb: 2.5,
            textAlign: "center",
            background: "linear-gradient(135deg, #fde7ec, #fbd0da)",
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              mx: "auto",
              mb: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#e8617a",
              color: "#fff",
            }}
          >
            <ErrorOutlineRoundedIcon />
          </Box>
          <Typography sx={{ fontWeight: 800, fontSize: "20px", color: "#8a1f33" }}>
            {t('streak.atRiskTitle')}
          </Typography>
          <Typography sx={{ color: "#a8324a", fontSize: "13px", mt: 0.5 }}>
            {t('streak.atRiskSubtitle')}
          </Typography>
        </Box>

        <Button
          fullWidth
          disabled={busy}
          onClick={onBuy}
          sx={{
            mb: 1.5,
            py: 1.2,
            borderRadius: 2.5,
            fontWeight: 800,
            fontSize: "15px",
            textTransform: "none",
            color: "#fff",
            background: "linear-gradient(135deg, #fa114f, #c4003a)",
            "&:hover": { background: "linear-gradient(135deg, #ff2f64, #d40040)" },
          }}
        >
          {price != null
            ? t('streak.atRiskBuyPriced', { price })
            : t('streak.atRiskBuy')}
        </Button>

        <Button
          fullWidth
          disabled={busy}
          onClick={onStartFresh}
          sx={{
            py: 1.1,
            borderRadius: 2.5,
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "none",
            color: "#444",
            border: "1px solid #ddd",
          }}
        >
          {busy ? t('streak.atRiskPleaseWait') : t('streak.atRiskStartFresh')}
        </Button>

        <Button
          fullWidth
          onClick={onLater}
          sx={{
            mt: 1.25,
            py: 1,
            borderRadius: 2.5,
            fontWeight: 700,
            fontSize: "13px",
            textTransform: "none",
            color: "#444",
            background: "#eceef3",
            border: "1px solid #d9dce3",
            "&:hover": { background: "#e0e3ea" },
          }}
        >
          {t('streak.atRiskLater')}
        </Button>
      </Box>
    </Box>
  );
};

export default StreakAtRisk;
